"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.installChunkErrorGlobalHandler = exports.forceReloadToHome = exports.forceReload = exports.tryAutoReload = exports.isChunkLoadError = void 0;
const RELOAD_FLAG = 'chunk-error-reloaded';
const CACHE_BUST_PARAM = '_v';
const isChunkLoadError = (err) => {
    var _a, _b;
    if (!err || typeof err !== 'object')
        return false;
    const e = err;
    const name = (_a = e.name) !== null && _a !== void 0 ? _a : '';
    const message = (_b = e.message) !== null && _b !== void 0 ? _b : '';
    return (name === 'ChunkLoadError' ||
        /Loading chunk \S+ failed/i.test(message) ||
        /Loading CSS chunk \S+ failed/i.test(message) ||
        /Failed to fetch dynamically imported module/i.test(message) ||
        /error loading dynamically imported module/i.test(message));
};
exports.isChunkLoadError = isChunkLoadError;
// Hard-refresh equivalent from JS: clear service-worker caches, unregister any
// service workers, then reload with a cache-buster query param so the document
// itself cannot be served from the HTTP cache. The new HTML references new
// content-hashed JS, so subresources also get fresh fetches.
// If `targetPath` is provided, navigate there instead of reloading current URL.
const performReload = (targetPath) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined')
        return;
    if ('caches' in window) {
        try {
            const names = yield caches.keys();
            yield Promise.all(names.map((n) => caches.delete(n)));
        }
        catch (_a) {
            /* ignore */
        }
    }
    if ('serviceWorker' in navigator) {
        try {
            const regs = yield navigator.serviceWorker.getRegistrations();
            yield Promise.all(regs.map((r) => r.unregister()));
        }
        catch (_b) {
            /* ignore */
        }
    }
    const url = targetPath
        ? new URL(targetPath, window.location.origin)
        : new URL(window.location.href);
    url.searchParams.set(CACHE_BUST_PARAM, Date.now().toString());
    window.location.replace(url.toString());
});
// Triggers a one-shot auto-reload. Guarded by sessionStorage so a reload that
// still fails (e.g. a real bug, not a stale deploy) does not loop.
const tryAutoReload = (delayMs = 1500) => {
    if (typeof window === 'undefined')
        return false;
    if (sessionStorage.getItem(RELOAD_FLAG))
        return false;
    sessionStorage.setItem(RELOAD_FLAG, '1');
    window.setTimeout(() => {
        void performReload();
    }, delayMs);
    return true;
};
exports.tryAutoReload = tryAutoReload;
const forceReload = () => {
    if (typeof window === 'undefined')
        return;
    sessionStorage.removeItem(RELOAD_FLAG);
    void performReload();
};
exports.forceReload = forceReload;
const forceReloadToHome = () => {
    if (typeof window === 'undefined')
        return;
    sessionStorage.removeItem(RELOAD_FLAG);
    void performReload('/');
};
exports.forceReloadToHome = forceReloadToHome;
// Install once at the very top of the entry file so chunk failures during
// the initial dynamic import (./bootstrap) are also handled.
const installChunkErrorGlobalHandler = () => {
    if (typeof window === 'undefined')
        return;
    const flag = '__chunkErrHandlerInstalled';
    const w = window;
    if (w[flag])
        return;
    w[flag] = true;
    // Strip the cache-buster param from the URL after a successful reload so
    // users don't see it in the address bar.
    try {
        const url = new URL(window.location.href);
        if (url.searchParams.has(CACHE_BUST_PARAM)) {
            url.searchParams.delete(CACHE_BUST_PARAM);
            const search = url.searchParams.toString();
            const cleaned = url.pathname + (search ? `?${search}` : '') + url.hash;
            window.history.replaceState({}, '', cleaned);
        }
    }
    catch (_a) {
        /* ignore */
    }
    window.addEventListener('unhandledrejection', (event) => {
        if ((0, exports.isChunkLoadError)(event.reason)) {
            event.preventDefault();
            (0, exports.tryAutoReload)();
        }
    });
    window.addEventListener('error', (event) => {
        if ((0, exports.isChunkLoadError)(event.error)) {
            (0, exports.tryAutoReload)();
        }
    });
    // Best-effort cleanup when the user navigates away (incl. browser refresh).
    // Deletes are fire-and-forget — the browser won't wait for promises here,
    // but service-worker caches that complete deletion before the next load
    // will be gone. The browser HTTP cache cannot be controlled from JS.
    window.addEventListener('pagehide', () => {
        if ('caches' in window) {
            void caches.keys().then((names) => Promise.all(names.map((n) => caches.delete(n))));
        }
    });
    // After 10s of healthy runtime, clear the guard so a future deploy can
    // trigger another auto-reload.
    window.setTimeout(() => {
        sessionStorage.removeItem(RELOAD_FLAG);
    }, 10000);
};
exports.installChunkErrorGlobalHandler = installChunkErrorGlobalHandler;
